<div class="min-h-screen bg-[#F3F4F6] text-sm dark:bg-slate-900 p-4 md:p-8   text-slate-600 dark:text-slate-300">
    <!-- Header -->
    <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
        <div>
            <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">
                จัดการข้อมูลผู้ให้บริการ
            </h1>
            <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
                จัดการข้อมูลรายชื่อผู้ให้บริการและรายละเอียดที่เกี่ยวข้อง</p>
        </div>
        <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
            <button (click)="onRefresh()"
                class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 dark:hover:text-amber-400 hover:shadow-md transition-all active:scale-95 flex items-center justify-center"
                title="รีเฟรชข้อมูล">
                <span class="material-icons">refresh</span>
            </button>
            <button (click)="navigateToCreate()"
                class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-[0_4px_15px_rgb(251,191,36,0.3)] hover:shadow-[0_8px_25px_rgb(251,191,36,0.4)] hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-2">
                <span class="material-icons text-xl">add_circle</span>
                เพิ่มผู้ให้บริการ
            </button>
        </div>
    </div>

    <!-- Stats Box -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div *ngFor="let stat of dashboardStats; let i = index"
            class="animate-fade-in bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] dark:hover:shadow-[0_8px_30px_rgb(0,0,0,0.3)] hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group"
            [ngStyle]="{'animation-delay': (i * 0.05) + 's'}">

            <!-- Background Icon Decoration -->
            <div class="absolute -right-6 -top-6 w-32 h-32 rounded-full opacity-[0.08] dark:opacity-10 transition-transform group-hover:scale-110"
                [ngClass]="stat.color.split(' ')[0].replace('text-', 'bg-')"></div>

            <div class="relative z-10 flex justify-between items-start mb-4">
                <div class="w-auto min-w-12 h-12 p-2 rounded-xl flex items-center justify-center shadow-sm"
                    [ngClass]="stat.color.replace('text-', 'bg-').replace('600', '50').replace('500', '50') + ' ' + stat.color + ' dark:bg-opacity-20'">
                    <span class="material-icons text-2xl">{{ stat.icon }}</span>
                </div>
            </div>

            <div class="relative z-10">
                <h4 class="text-slate-400 text-xs font-bold uppercase tracking-wider mb-1 truncate">{{ stat.title }}
                </h4>
                <div class="text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">{{ stat.value }}
                </div>
            </div>
        </div>
    </div>

    <div class="animate-fade-in bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden"
        style="animation-delay: 0.2s;">

        <div
            class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col md:flex-row md:items-center justify-between gap-4">
            <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
                <span class="material-icons text-amber-500">business</span>
                รายการผู้ให้บริการ
            </h3>

            <div class="flex flex-col xl:flex-row gap-3 w-full xl:w-auto">
                <!-- Site Filter -->
                <div class="relative min-w-[150px]">
                    <button (click)="toggleFilterDropdown()"
                        class="w-full flex items-center justify-between px-4 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-50 dark:border-slate-800 rounded-xl h-[46px] shadow-sm text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-white dark:hover:bg-slate-800 transition-all">
                        <span class="flex items-center gap-2">
                            <span class="material-icons text-lg text-slate-400">place</span>
                            โครงการ
                        </span>
                        <span class="material-icons text-sm text-slate-400 transition-transform duration-200"
                            [ngClass]="{'rotate-180': isFilterDropdownOpen}">expand_more</span>
                    </button>

                    <button *ngIf="isFilterDropdownOpen" class="fixed inset-0 cursor-default z-30"
                        (click)="toggleFilterDropdown()"></button>

                    <div *ngIf="isFilterDropdownOpen"
                        class="absolute top-full right-0 mt-2 w-[220px] bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-2 z-40 animate-fade-in-up">
                        <div class="px-4 py-2 text-xs font-bold text-slate-400 uppercase tracking-wider">เลือกโครงการ
                        </div>
                        <div *ngFor="let site of parkingSiteList?.data">
                            <label
                                class="flex items-center gap-3 px-4 py-2 hover:bg-slate-50 dark:hover:bg-slate-700 cursor-pointer transition-colors">
                                <input type="checkbox" [checked]="selectedSite === site.id"
                                    (change)="toggleSiteFilter(site.id)"
                                    class="w-4 h-4 text-amber-500 border-slate-300 rounded focus:ring-amber-500">
                                <span class="text-sm font-medium text-slate-600 dark:text-slate-300">{{ site.name
                                    }}</span>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- Search Input -->
                <div class="relative flex-1 flex w-full xl:min-w-[350px]">
                    <div
                        class="relative w-full flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all overflow-hidden h-[46px]">
                        <span
                            class="absolute left-3 material-icons text-slate-400 dark:text-slate-500 text-xl">search</span>
                        <input type="text" placeholder="ค้นหาชื่อ, ที่อยู่, เลขภาษี..." [(ngModel)]="searchText"
                            (keyup.enter)="onSearch()"
                            class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-600">
                        <button (click)="onSearch()"
                            class="h-full px-5 text-sm font-bold text-white bg-amber-400 hover:bg-amber-500 transition-colors whitespace-nowrap">
                            ค้นหา
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="overflow-x-auto h-[600px] relative custom-scrollbar">
            <app-pss-loading *ngIf="isLoading"></app-pss-loading>

            <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading"
                [class.pointer-events-none]="isLoading">
                <thead
                    class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 backdrop-blur-sm shadow-sm border-b border-slate-100 dark:border-slate-700">
                    <tr class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest">
                        <th (click)="sortData('id')"
                            class="p-4 whitespace-nowrap cursor-pointer hover:text-slate-600 transition-colors group">
                            <div class="flex items-center gap-1">
                                ID
                                <span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn === 'id'">
                                    {{ sortColumn === 'id' && sortDirection === 'asc' ? 'arrow_upward' :
                                    'arrow_downward' }}
                                </span>
                            </div>
                        </th>
                        <th (click)="sortData('name')"
                            class="p-4 whitespace-nowrap cursor-pointer hover:text-slate-600 transition-colors group">
                            <div class="flex items-center gap-1">
                                ชื่อผู้ให้บริการ
                                <span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn === 'name'">
                                    {{ sortColumn === 'name' && sortDirection === 'asc' ? 'arrow_upward' :
                                    'arrow_downward' }}
                                </span>
                            </div>
                        </th>
                        <th (click)="sortData('address')"
                            class="p-4 whitespace-nowrap cursor-pointer hover:text-slate-600 transition-colors group">
                            <div class="flex items-center gap-1">
                                ที่อยู่
                                <span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn === 'address'">
                                    {{ sortColumn === 'address' && sortDirection === 'asc' ? 'arrow_upward' :
                                    'arrow_downward' }}
                                </span>
                            </div>
                        </th>
                        <th (click)="sortData('phoneNumber')"
                            class="p-4 whitespace-nowrap cursor-pointer hover:text-slate-600 transition-colors group">
                            ที่อยู่
                        </th>
                        <th (click)="sortData('taxId')"
                            class="p-4 whitespace-nowrap cursor-pointer hover:text-slate-600 transition-colors group">
                            <div class="flex items-center gap-1">
                                เลขประจำตัวผู้เสียภาษี
                                <span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn === 'taxId'">
                                    {{ sortColumn === 'taxId' && sortDirection === 'asc' ? 'arrow_upward' :
                                    'arrow_downward' }}
                                </span>
                            </div>
                        </th>
                        <th (click)="sortData('branch')"
                            class="p-4 whitespace-nowrap text-center cursor-pointer hover:text-slate-600 transition-colors group">
                            สาขา
                        </th>
                        <th (click)="sortData('vat')"
                            class="p-4 whitespace-nowrap text-center cursor-pointer hover:text-slate-600 transition-colors group">
                            Vat
                        </th>
                        <th (click)="sortData('shortName')"
                            class="p-4 whitespace-nowrap cursor-pointer hover:text-slate-600 transition-colors group">
                            <div class="flex items-center gap-1">
                                ชื่อย่อ
                                <span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn === 'shortName'">
                                    {{ sortColumn === 'shortName' && sortDirection === 'asc' ? 'arrow_upward' :
                                    'arrow_downward' }}
                                </span>
                            </div>
                        </th>
                        <th (click)="sortData('site')"
                            class="p-4 whitespace-nowrap cursor-pointer hover:text-slate-600 transition-colors group">
                            <div class="flex items-center gap-1">
                                พื้นที่บริการ
                                <span
                                    class="material-icons text-[14px] opacity-0 group-hover:opacity-100 text-amber-500 transition-all"
                                    [class.opacity-100]="sortColumn === 'site'">
                                    {{ sortColumn === 'site' && sortDirection === 'asc' ? 'arrow_upward' :
                                    'arrow_downward' }}
                                </span>
                            </div>
                        </th>
                        <th class="p-4 whitespace-nowrap text-center">จัดการ</th>
                    </tr>
                </thead>

                <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
                    <tr *ngFor="let p of filteredAndPaginatedData; let i = index; trackBy: trackByProviderId"
                        (click)="openEditModal(p)"
                        class="animate-table-row group hover:bg-amber-50/40 dark:hover:bg-slate-700/50 transition-colors duration-200 cursor-pointer"
                        [ngStyle]="{'animation-delay': (i * 0.03) + 's'}">

                        <td
                            class="p-4 font-mono text-sm text-slate-600 dark:text-slate-300 font-bold whitespace-nowrap">
                            {{ p.id }}
                        </td>

                        <td class="p-4 whitespace-nowrap">
                            <div class="flex items-center gap-3">
                                <div
                                    class="shrink-0 w-8 h-8 rounded-full bg-slate-100 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 flex items-center justify-center text-slate-500 dark:text-slate-400 font-bold text-xs shadow-sm group-hover:bg-white dark:group-hover:bg-slate-800 group-hover:text-amber-500 dark:group-hover:text-amber-400 transition-colors">
                                    {{ p.name ? p.name.charAt(0) : 'P' }}
                                </div>
                                <span class="text-sm font-bold text-slate-700 dark:text-slate-200">{{ p.name || '-'
                                    }}</span>
                            </div>
                        </td>

                        <td class="p-4 max-w-[250px]">
                            <div class="text-sm text-slate-600 dark:text-slate-300 truncate" [title]="p.address">
                                {{ p.address || '-' }}
                            </div>
                        </td>

                        <td class="p-4 text-sm text-slate-600 dark:text-slate-300 whitespace-nowrap">
                            {{ p.phoneNumber || '-' }}
                        </td>

                        <td class="p-4 text-sm text-slate-600 dark:text-slate-300 font-mono whitespace-nowrap">
                            {{ p.taxId || '-' }}
                        </td>

                        <td class="p-4 text-sm text-slate-600 dark:text-slate-300 text-center whitespace-nowrap">
                            {{ p.branch || '-' }}
                        </td>

                        <td class="p-4 text-center">
                            <span *ngIf="p.vat"
                                class="px-2 py-0.5 bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-400 text-xs font-bold rounded-md border border-green-200 dark:border-green-800">
                                {{ p.vat }}%
                            </span>
                            <span *ngIf="!p.vat" class="text-slate-400">-</span>
                        </td>

                        <td class="p-4 text-sm font-bold text-amber-600 dark:text-amber-400 whitespace-nowrap">
                            {{ p.shortName || '-' }}
                        </td>

                        <td class="p-4 text-sm text-slate-600 dark:text-slate-300 whitespace-nowrap">
                            <div class="flex items-center gap-1.5">
                                <span class="material-icons text-[16px] text-slate-400">place</span>
                                {{ p.site || '-' }}
                            </div>
                        </td>

                        <td class="p-4 text-center whitespace-nowrap relative z-10">
                            <button (click)="openEditModal(p); $event.stopPropagation();"
                                class="inline-flex items-center justify-center w-8 h-8 rounded-lg text-blue-500 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30 hover:bg-blue-500 dark:hover:bg-blue-600 hover:text-white transition-all shadow-sm hover:shadow-blue-200 dark:hover:shadow-blue-900/50 hover:scale-110 active:scale-95"
                                title="จัดการข้อมูล">
                                <span class="material-icons text-[18px]">edit</span>
                            </button>
                        </td>
                    </tr>

                    <tr *ngIf="filteredAndPaginatedData.length === 0 && !isLoading">
                        <td [attr.colspan]="10" class="py-20 text-center">
                            <div class="flex flex-col items-center justify-center">
                                <div
                                    class="w-16 h-16 bg-slate-50 dark:bg-slate-800 rounded-full flex items-center justify-center mb-3">
                                    <span
                                        class="material-icons text-3xl text-slate-300 dark:text-slate-600">search_off</span>
                                </div>
                                <h3 class="text-slate-800 dark:text-slate-200 font-bold">ไม่พบข้อมูล</h3>
                                <span
                                    class="text-slate-400 dark:text-slate-500 text-sm mt-1">ลองปรับตัวกรองหรือค้นหาใหม่อีกครั้ง</span>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination Footer -->
        <div
            class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-4 w-full">
            <div class="flex items-center gap-4 text-sm text-slate-500 dark:text-slate-400 font-medium">
                <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems | number }}
                    รายการ</span>
                <select (change)="onPageSizeChange($event)" [(ngModel)]="pageSize"
                    class="bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-200 text-sm rounded-lg focus:ring-2 focus:ring-amber-100 dark:focus:ring-amber-500/30 focus:border-amber-400 dark:focus:border-amber-600 block p-1.5 pr-8 font-bold outline-none cursor-pointer hover:bg-white dark:hover:bg-slate-800 transition-colors">
                    <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
                </select>
            </div>

            <div class="flex items-center gap-2">
                <button (click)="setPage(currentPage - 1)" [disabled]="currentPage === 1"
                    class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400">
                    <span class="material-icons text-sm">chevron_left</span>
                </button>

                <button *ngFor="let page of pagesArray" (click)="setPage(page)"
                    class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
                    [ngClass]="page === currentPage ? 'bg-amber-400 dark:bg-amber-500 text-white shadow-lg shadow-amber-200 dark:shadow-none' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600 dark:hover:text-amber-400'">
                    {{ page }}
                </button>

                <button (click)="setPage(currentPage + 1)" [disabled]="currentPage === totalPages || totalPages === 0"
                    class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400">
                    <span class="material-icons text-sm">chevron_right</span>
                </button>
            </div>
        </div>
    </div>

    <!-- Modals -->
    <app-modal-provider-parking *ngIf="isModalOpen" [provider]="selectedProvider" (close)="closeModal()"
        (saveSuccess)="onSaveSuccess()">
    </app-modal-provider-parking>

</div>